import { createFeature, createReducer, on } from '@ngrx/store';
import { CasePreviewAuditModels } from '@models/case-preview-audit.model';
import { CasePreviewAuditActions } from '@states/case-preview-audit/case-preview-audit.actions';

export interface CasePreviewAuditState {
  isLoading: boolean;
  response: CasePreviewAuditModels.Response | null;
}

export const initialState: CasePreviewAuditState = {
  isLoading: false,
  response: null,
};

export const casePreviewAuditFeature = createFeature({
  name: 'casePreviewAudit',
  reducer: createReducer(
    initialState,
    on(CasePreviewAuditActions.resetState, () => ({ ...initialState })),
    on(CasePreviewAuditActions.loadAudit, (state) => ({
      ...state,
      isLoading: true,
    })),
    on(CasePreviewAuditActions.loadAuditSuccess, (state, { response }) => ({
      ...state,
      isLoading: false,
      response,
    })),
    on(CasePreviewAuditActions.loadAuditFail, (state) => ({
      ...state,
      isLoading: false,
    })),
  ),
});
